import { mainSplitApi } from "../../api";

const common = mainSplitApi.injectEndpoints({
    endpoints: build => ({
        getCommissioningReportData: build.query({
            query: arg => ({
                url: `digitized_reports/commissioning/report`,
                params: { ...arg },
            }),
        }),
        updateCommissioningReport: build.mutation({
            query: body => {
                return ({
                    url: `/digitized_reports/commissioning/report`,
                    method: "PUT",
                    body,
                })
            },
        }),
        getPresignedUrl: build.mutation({
            query: body => ({
                url: `digitized_reports/generate_presigned_url`,
                method: "POST",
                body,
            }),
        }),
        getCommissioningReportTemplateImages: build.query({
            query: arg => {
                return {
                    url: `digitized_reports/commissioning/templates`,
                    params: { ...arg },
                }
            },
        }),
        uploadFileToPresignedUrl: build.mutation({
            query: (arg: any) => {
                return {
                    url: arg.url,
                    method: "PUT",
                    body: arg.payload,
                }
            },
            
        }),
        submitCommissioningReport: build.mutation({
            query: body => {
                return ({
                    url: `/digitized_reports/commissioning/report`,
                    method: "POST",
                    body,
                })
            },
        }),
        sendOtpApi: build.mutation({
            query: body => {
                return ({
                    url: `/digitized_reports/send_otp`,
                    method: "POST",
                    body,
                })
            },
        }),
        resendOtpApi: build.mutation({
            query: body => {
                return ({
                    url: `/digitized_reports/resend_otp`,
                    method: "POST",
                    body,
                })
            },
        }),
        verifyOtpApi: build.mutation({
            query: body => {
                return ({
                    url: `/digitized_reports/verify_otp`,
                    method: "POST",
                    body,
                })
            },
        }),
    }),
})

export const {
    useGetCommissioningReportDataQuery,
    useUpdateCommissioningReportMutation,
    useGetPresignedUrlMutation,
    useLazyGetCommissioningReportTemplateImagesQuery,
    useUploadFileToPresignedUrlMutation,
    useSubmitCommissioningReportMutation,
    useLazyGetCommissioningReportDataQuery,
    useSendOtpApiMutation,
    useVerifyOtpApiMutation,
    useResendOtpApiMutation
} = common



